export default {
  tableLoading(state, value) {
    return (state.tableLoading = value);
  },

  currentPage(state, value) {
    return (state.currentPage = value);
  },

  jobPostings(state, projects) {
    state.jobPostings = projects;
  },

  archivedJobPostings(state, projects) {
    state.archivedJobPostings = projects;
  },

  jobBoards(state, projects) {
    state.jobBoards = projects;
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  setSelectedRow(state, value) {
    state.selectedRow = value;
  },

  setTrackingId(state, value) {
    state.trackingId = value;
  },

  setSelectedRowJobBoard(state, value) {
    state.selectedRowJobBoard = value;
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  paginationTotal(state, value) {
    return (state.total = value);
  },

  resetState(state) {
    state.currentPage = 1;
    state.perPage = 5;
    state.searchQuery = "";
    state.total = 0;
  },
};
